<template>
	<div class="col-sm-12 col-md-12 col-lg-12 col-xl-6 mb-4">
		<div class="card hm400">
			<div class="card-header ">
				<h5 class="card-title">Recent Support Tickets</h5>
				<!-- <p class="card-category">List of 3 recent support tickets</p> -->
			</div>
			<div class="card-body pb-0">
				<perfect-scrollbar class="scroll-area">
					<div class="loader" v-if="loaded === false"></div>
					<ul class="list-group list-group-flush" v-else>
						<li class="list-group-item d-flex justify-content-between align-items-center" v-for="(ticket, index) in latestTickets" :key="index">
							<router-link tag="p" class="mb-0 click-cursor" :to="{ name: 'viewTicket', params: { id: encryptIndex( ticket.ticket_number.toString() ) } }">
								{{ getTicketSubject(ticket.tsubject) }}<br>
								<strong class="text-secondary">#{{ ticket.ticket_number }}</strong>
							</router-link>
							<span class="badge badge-pill" :class="getTicketStatusClass(ticket.status)">{{ ticket.status }}</span>
						</li>
					</ul>
				</perfect-scrollbar>
			</div>
			<div class="card-footer pt-0">
				<hr class="mt-0">
				<div class="stats">
					<router-link tag="a" :to="{ name: 'ticketsArchive' }" class="text-secondary nounderline">
						<i class="fa fa-ticket"></i> View All
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import AES from 'crypto-js/aes';
import {PerfectScrollbar} from 'vue2-perfect-scrollbar';



export default {
  name: "SupportTicketsList",
	computed: {
    loaded() {
      return this.$store.getters['tickets/loaded']
		},
		latestTickets() {
			return this.$store.getters['tickets/latestTickets']
		},
		aesSecret() {
      return this.$store.getters["crypto/aesSecret"];
    }
  },
	components: {
		PerfectScrollbar,
	},
  methods: {
		encryptIndex(index) {
      return AES.encrypt(index, this.aesSecret).toString()
    },
		getTicketSubject(tsubject) {
			const strSplit = tsubject.split('-')
			strSplit.splice(0, 1)
			const sub = strSplit.join('-')
			return sub.trim()
		},
		getTicketStatusClass(status) {
			return {
				"badge-success": status === "Answered",
				"badge-warning": status === "In-Progress",
				"badge-info": (status === "Open" || status === "Sales Followup"),
				"badge-primary": (status === "Client-Reply" || status === "Waiting on Billing"),
				"badge-default": status === "Closed"
			}
		}
  },
  created() {
		this.$store.dispatch('tickets/fetchTickets')
	}
};
</script>

<style lang="scss">
.click-cursor {
	cursor: pointer;
}
</style>
